import { Box, Grid, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import FeedbackTab from './components/FeedbackTab';
import ProfileTab from './components/ProfileTab';
import NotificationSettingsTab from './components/NotificationSettingsTab';
import SupportTab from './components/SupportTab';
import PrivacyPolicyTab from './components/PrivacyPolicyTab';
import { useSearchParams } from 'react-router-dom';

export default function SettingsPage() {
  const [searchParams, setSearchParams] = useSearchParams();

  const onTabChange = (event: React.SyntheticEvent, value: string) => {
    setSearchParams({ tab: value });
  };

  const tab = searchParams.get('tab') || 'profile';

  return (
    <Grid container direction={'column'} sx={{ maxWidth: { xs: '305px', sm: '100%' } }}>
      <Grid item>
        <Box sx={styles.boxContainer}>
          <Tabs
            scrollButtons
            variant='scrollable'
            allowScrollButtonsMobile
            value={tab}
            onChange={onTabChange}
            sx={styles.tabContainer}
          >
            <Tab value={'profile'} label='Profile' />
            <Tab value={'feedback'} label='Give Feedback' />
            <Tab value={'notifications'} label='Notification Settings' />
            <Tab value={'support'} label='Support' />
            <Tab value={'privacyPolicy'} label='Privacy Policy' />
          </Tabs>
        </Box>
        <Grid item paddingTop={3}>
          {tab === 'profile' && <ProfileTab />}
          {tab === 'feedback' && <FeedbackTab />}
          {tab === 'notifications' && <NotificationSettingsTab />}
          {tab === 'support' && <SupportTab />}
          {tab === 'privacyPolicy' && <PrivacyPolicyTab />}
        </Grid>
      </Grid>
    </Grid>
  );
}

const styles = {
  tabContainer: {
    maxWidth: {
      xs: 285, // sets the width to 320px when the screen size is xs
      sm: 'none',
    },
    width: '100%',
  },
  boxContainer: {
    borderBottom: 1,
    borderColor: 'divider',
  },
};
